var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordResetAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10871_49669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24C5.38268 24 0 18.6173 0 12.0007C0 5.38401 5.38268 0 12.0007 0C18.6187 0 24.0013 5.38268 24.0013 12.0007C24.0013 18.6186 18.6187 24 12.0007 24ZM12.0007 1.32971C6.11668 1.32971 1.32971 6.11668 1.32971 12.0007C1.32971 17.8846 6.11668 22.6703 12.0007 22.6703C17.8846 22.6703 22.6716 17.8833 22.6716 12.0007C22.6716 6.11801 17.8833 1.32971 12.0007 1.32971Z",
    fill: "#868E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 17.2691C10.8984 16.5975 11.3652 16.1109 11.9994 16.1109C12.6709 16.1109 13.1004 16.5962 13.1004 17.2691C13.1004 17.9419 12.6709 18.4272 11.9994 18.4272C11.3279 18.4272 10.8984 17.9233 10.8984 17.2691ZM11.3652 14.599L11.1032 5.63672H12.8957L12.6337 14.599H11.3638H11.3652Z",
    fill: "#868E96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10871_49669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordResetAttention);
export default __webpack_public_path__ + "static/media/password_reset_attention.4a9d5efe.svg";
export { ForwardRef as ReactComponent };